export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14 2a4 4 0 014 4v1.5h1a4 4 0 014 4V16a4 4 0 01-4 4h-2v-2h2a2 2 0 002-2v-4.5a2 2 0 00-2-2h-1v1a4 4 0 01-4 4H8V16a2 2 0 002 2h2.586a2 2 0 011.414.586l3.207 3.207-1.414 1.414L12.586 20H10a4 4 0 01-4-4v-1.5H5a4 4 0 01-4-4V6a4 4 0 014-4h9zM5 4a2 2 0 00-2 2v4.5a2 2 0 002 2h1v-1a4 4 0 014-4h6V6a2 2 0 00-2-2H5zm5 5.5a2 2 0 00-2 2v1h6a2 2 0 002-2v-1h-6z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};